import Container from 'quarks/Container';

import Blocks from 'molecules/Backgrounds/Blocks';
import LightsBackground from 'molecules/Backgrounds/Lights';
import HeadingMolecule from 'molecules/Heading/Heading';
import type { HeadingProps } from 'molecules/Heading/Heading';
import Section, { withAlwaysDarkSection } from 'molecules/Section/Section';
import type { SectionBuilderProps } from 'molecules/Section/Section';

import useAlwaysDark from 'contexts/SectionThemeProvider';

import { fitParent } from 'theme/helpers';

import type { FC } from 'react';

interface ConversionPanelProps extends HeadingProps, SectionBuilderProps {}

const ConversionPanel: FC<ConversionPanelProps> = ({
  heading,
  headingType,
  body,
  eyebrow,
  buttons,
  forms,
  shadeBackgroundLightMode,
  shadeBackgroundDarkMode,
}) => {
  const { isAlwaysDark, isDarkMode } = useAlwaysDark();

  return (
    <Section
      alwaysDark={isAlwaysDark}
      shadeBackgroundLightMode={shadeBackgroundLightMode}
      shadeBackgroundDarkMode={shadeBackgroundDarkMode}
    >
      {(isDarkMode || isAlwaysDark) && (
        <>
          <LightsBackground model="conversionPanel" />
          <Blocks position="bottom" blockPath="conversionPanel" />
        </>
      )}
      <Container
        position="relative"
        paddingX={24}
        paddingY={48}
        backgroundColor={{ dark: 'common-black', light: 'common-white', isAlwaysDark }}
        border="1px solid"
        borderColor={{ dark: 'alphaWhite-300', light: 'common-transparent', isAlwaysDark }}
        sm={{
          paddingAll: 64,
          borderRadius: '8px',
          boxShadow: 'xl',
        }}
        before={{
          content: isDarkMode || isAlwaysDark ? '' : undefined,
          position: 'absolute',
          top: '45px',
          bottom: '45px',
          left: '60px',
          right: '60px',
          width: 'auto',
          border: '1px solid',
          borderColor: 'gray-800',
          backgroundSize: '50px 50px',
          backgroundImage: 'darkConversionPanel-grid',
        }}
        after={{
          content: isDarkMode || isAlwaysDark ? '' : undefined,
          ...fitParent,
          borderRadius: '8px',
          backgroundImage: 'darkConversionPanel-gridOverlay',
        }}
      >
        <HeadingMolecule
          heading={heading}
          headingType={headingType}
          body={body}
          eyebrow={eyebrow}
          buttons={buttons}
          forms={forms}
          size="xxs"
          position="relative"
          headingAlignment="center"
          maxWidth="770px"
          zIndex={1}
        />
      </Container>
    </Section>
  );
};

export default withAlwaysDarkSection(ConversionPanel);
